import {IAwayFromKeyboardController} from "./IAwayFromKeyboardController";
/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 11.11.13
 * Time: 17:01
 * To change this template use File | Settings | File Templates.
 */
import {BasicModel} from "../../model/BasicModel";
import {BasicDebugHud} from "../../view/debug/BasicDebugHud";
import {Timer} from "@goodgamestudios/createjs-utilities";

import Container = createjs.Container;
import Event = createjs.Event;
import TimerEvent = createjs.TimerEvent;

/**
 * BasicAFKController monitors the user's activity status with the help of "activate"- and "deactivate"-events.
 * If our player clicks somewhere else outside of the game-swf, controller starts a timer.
 * After five minutes the status of user ( _userIsActive ) will be changed to "false".
 * If player does something in the game, _userIsActive changes to "true" immediately and the afkTimer stops.
 *
 * Results of the monitoring are sent to the server.
 */

export class ExtendedAwayFromKeyboardController implements IAwayFromKeyboardController {
    private _userIsActive: boolean = true;
    private _afkTimer: Timer;

    private static AFK_TIME: number = 300000;
    private static AFK_COUNTER: number = 1;
    private static SERVER_COMMAND_ID: string = "core_afk";

    constructor(target: Container) {
        target.addEventListener(Event.ACTIVATE, this.activateHandler);
        target.addEventListener(Event.DEACTIVATE, this.deactivateHandler);

        this._afkTimer = new Timer(ExtendedAwayFromKeyboardController.AFK_TIME, ExtendedAwayFromKeyboardController.AFK_COUNTER);
        this._afkTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.afkTimerHandler));

        // It's necessary to start the timer immediately because of users, who opens the game and
        // does nothing more. This group of players must be equated as AFK-players after 5 minutes.
        this._afkTimer.start();
    }


    public activateHandler(event: Event): void {

        this.stopAndResetTimer();

        if (!this._userIsActive && BasicModel.smartfoxClient.isConnected) {
            //debug("User is not active and connected to the internet. But now is he again in the game.");
            // User is back to the game. Disable pixel and send activity-message to the server.

            this._userIsActive = true;
            BasicDebugHud.updateAwayFromKeyboardPixelVisibility(this._userIsActive);
            this.sendActivityStatusToServer();
        }
    };


    public deactivateHandler(event: Event): void {

        // User is no more active. Start the AFK-timer.
        this._afkTimer.start();
    };

    private afkTimerHandler(event: TimerEvent): void {
        this.stopAndResetTimer();

        if (this._userIsActive && BasicModel.smartfoxClient.isConnected) {
            // User is AFK. Show the pixel and send "deactivity"-message to the server.

            this._userIsActive = false;
            BasicDebugHud.updateAwayFromKeyboardPixelVisibility(this._userIsActive);
            this.sendActivityStatusToServer();
        }
    };

    private stopAndResetTimer(): void {
        this._afkTimer.stop();
        this._afkTimer.reset();
    }

    private sendActivityStatusToServer(): void {
        BasicModel.smartfoxClient.sendMessage(ExtendedAwayFromKeyboardController.SERVER_COMMAND_ID, [this._userIsActive]);
    }
}

